import {StyleSheet} from 'react-native';

import {styles as radioStyles} from '/component/base/RadioButton/RadioButton.style';

export const checkboxUncheckedStyle = {
  icon: [radioStyles.checkboxIcon],
};

export const checkboxCheckedStyle = {
  icon: [radioStyles.checkboxIcon, radioStyles.checkboxIconSelected],
};

export const styles = StyleSheet.create({
  headerText: {
    fontSize: 14,
  },
  inputSectionSpacing: {
    marginTop: 10,
  },
  inputSectionBottomSpacing: {
    marginBottom: 14,
  },
  errorTextWithMargin: {
    marginLeft: 10,
  },
  rangeSeparator: {
    width: 10,
    height: 1,
    alignSelf: 'center',
  },
});
